import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/empty';
import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from "@angular/router";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';


@Injectable()
export class HttpErrorsResponseIntenceptor implements HttpInterceptor {
  constructor(
    private route: Router,
    private toastr: ToastsManager,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req.clone())
      .catch((event) => {
        if (event instanceof HttpErrorResponse) {
          return this.handleError(event);
        }
      });
  }

  // Response Interceptor
  private handleError(error: HttpErrorResponse): Observable<any> {
    if (error.status === 400) {
      console.log('Bad request', error);
      return Observable.throw(error.error)
    } else if (error.status === 401) {
      console.error('Unauthorized', error);
      this.toastr.warning('Su sesión ha caducado!', 'Oops!').then();
      this.route.navigate(['/']).then();
    } else if (error.status === 403) {
      console.error('Forbidden', error);
      this.toastr.warning('Operación no permitida!', 'Oops!').then();
    } else if (error.status === 409) {
      return Observable.throw(error)
    } else if (error.status === 500 || error.status === 405) {
      console.error('An error occurred', error);
      this.toastr.error('Ocurrió un error!', 'Oops!').then();
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/http/http.errors.response.ts